import { Tooltip, TooltipProps } from 'antd'
import { FC, PropsWithChildren } from 'react'
import Styled from './styled'

interface ITooltipIcon extends PropsWithChildren, Pick<TooltipProps, 'title' | 'placement'> {
	color?: string
}

const TooltipIcon: FC<ITooltipIcon> = ({ color, placement, children, title }) => (
	<Tooltip placement={placement} title={title}>
		<Styled.Wrapper $color={color}>{children}</Styled.Wrapper>
	</Tooltip>
)

export default TooltipIcon
